/* global google */
var youbora = require('youboralib')

var FreewheelAdsAdapter = youbora.Adapter.extend({
  getVersion: function () {
    if (this.player.FreeWheelPlugin) {
      if (typeof google !== 'undefined' && google.ima) {
        if (this.player.FreeWheelPlugin && this.player.FreeWheelPlugin.version) {
          return 'bcove-ima ' + this.player.FreeWheelPlugin.version + ' / IMA' + google.ima.VERSION
        } else {
          return 'bcove-ima ' + google.ima.VERSION
        }
      } else if (this.player.FreeWheelPlugin.getVersion) {
        return 'bcove-fw ' + this.player.FreeWheelPlugin.getVersion()
      } else if (this.player.FreeWheelPlugin.VERSION) {
        return 'bcove-ssai ' + this.player.FreeWheelPlugin.VERSION
      } else {
        return 'UNKNOWN'
      }
    } else {
      return 'bcove-ssai ' + this.player.ads.VERSION
    }
  },

  getDuration: function () {
    if (this.player.ads && this.player.ads.ad && this.player.ads.ad.duration) {
      return this.player.ads.ad.duration
    }
    var player = this.plugin.player
    if (this.player.FreeWheelPlugin) {
      var tech = this.player.FreeWheelPlugin.tech
      if (this.player.FreeWheelPlugin[tech].adPlayer) {
        player = this.player.FreeWheelPlugin[tech].adPlayer
      }
    } else if (this.player.ima3) {
      player = this.player.ima3.adPlayer
    }
    return (player && player.duration) ? player.duration() : null
  },

  getPosition: function () {
    if (this.player.ads && this.player.ads.ad) {
      switch (this.player.ads.ad.type) {
        case 'PREROLL':
          return youbora.Constants.AdPosition.Preroll
        case 'MIDROLL':
          return youbora.Constants.AdPosition.Midroll
        case 'POSTROLL':
          return youbora.Constants.AdPosition.Postroll
      }
    }
    if (!this.plugin._adapter.flags.isJoined) {
      return youbora.Constants.AdPosition.Preroll
    } else if (this.plugin._adapter.getPlayhead() >= this.plugin._adapter.getDuration()) {
      return youbora.Constants.AdPosition.Postroll
    }
    return youbora.Constants.AdPosition.Midroll
  },

  getResource: function () {
    return this.player.ima3 ? this.player.ima3.currentAd.getMediaUrl() : 'unknown'
  },

  getTitle: function () {
    if (this.player.FreeWheelPlugin) {
      if (this.player.FreeWheelPlugin.adsManager && this.player.FreeWheelPlugin.adsManager.getCurrentAd()) {
        return this.player.FreeWheelPlugin.adsManager.getCurrentAd().getTitle()
      }
    } else if (this.player.ima3 && this.player.ima3.currentAd) {
      return this.player.ima3.currentAd.getTitle()
    }
    return null
  },

  getPlayhead: function () {
    var player = this.plugin.getAdapter().player
    if (this.player.FreeWheelPlugin) {
      if (this.player.FreeWheelPlugin.adPlayer) {
        player = this.player.FreeWheelPlugin.adPlayer
      }
    } else if (this.player.ima3) {
      if (this.player.ima3 && this.player.ima3.adPlayer) {
        player = this.player.ima3.adPlayer
      }
    }
    return player.currentTime()
  },

  getPlayerVersion: function () {
    if (this.player.ima3) {
      return this.player.ima3.VERSION
    }
    return null
  },

  getGivenBreaks: function () {
    if (this.player.FreeWheelPlugin) {
      var tech = this.player.FreeWheelPlugin.tech
      var slots = this.player.FreeWheelPlugin[tech]._adContext._adResponse.getTemporalSlots()
      var breaks = 0
      for (var slotindex in slots) {
        var slot = slots[slotindex]
        if (slot.getAdCount() > 0) {
          var ads = slot.getAdInstances()
          for (var adindex in ads) {
            if (ads[adindex]._creativeRenditions[0]._baseUnit === 'video') {
              breaks++
              break
            }
          }
        }
      }
      return breaks
    } else if (this.player.ima3) {
      return this.player.ima3.adsManager.getCuePoints().length
    }
  },

  getBreaksTime: function () {
    if (this.player.FreeWheelPlugin) {
      return null
    } else if (this.player.ima3) {
      var cuelist = this.player.ima3.adsManager.getCuePoints()
      for (var index in cuelist) {
        if ((!cuelist[index] && cuelist[index] !== 0) || cuelist[index] === -1) {
          cuelist[index] = this.plugin._adapter.getDuration()
        }
      }
      return cuelist
    }
  },

  getGivenAds: function () {
    if (this.player.FreeWheelPlugin) {
      var tech = this.player.FreeWheelPlugin.tech
      return this.player.FreeWheelPlugin[tech]._currentSlot.getAdCount()
    } else if (this.player.ima3 && this.player.ima3.currentAd && this.player.ima3.currentAd.getAdPodInfo()) {
      return this.player.ima3.currentAd.getAdPodInfo().getTotalAds()
    }
  },

  getAudioEnabled: function () {
    if (this.player.muted()) {
      return false
    }
    return !!this.player.volume()
  },

  getIsSkippable: function () {
    if (this.player.ima3) {
      return this.player.ima3.currentAd ? this.player.ima3.currentAd.isSkippable() : false
    }
    return false
  },

  getIsFullscreen: function () {
    if (this.plugin.deviceDetector.isIphone()) {
      return !this.plugin.deviceDetector.isInBackground
    }
    var container = null
    if (this.player.FreeWheelPlugin) {
      var tech = this.player.FreeWheelPlugin.tech
      container = this.player.FreeWheelPlugin[tech]._video
    } else if (this.player.ima3) {
      container = this.player.ima3.el
    }
    return container ? (window.innerHeight <= container.clientHeight + 30 && window.innerWidth <= container.clientWidth + 30) : false
  },

  getIsVisible: function () {
    if (this.plugin.deviceDetector.isIphone()) {
      return !this.plugin.deviceDetector.isInBackground
    }
    if (this.player.FreeWheelPlugin) {
      if (!this.contentPlayer) {
        var tech = this.player.FreeWheelPlugin.tech
        for (var key in this.player.FreeWheelPlugin[tech]) {
          var element = this.player.FreeWheelPlugin[tech][key]
          if (element.videoHeight && element.clientHeight) {
            this.contentPlayer = element
            break
          }
        }
      }
      return youbora.Util.calculateAdViewability(this.contentPlayer)
    } else if (this.player.ima3) {
      return youbora.Util.calculateAdViewability(this.player.ima3.el)
    }
  },

  getBitrate: function () {
    var bitrate = -1
    if (this.player.ima3 && this.player.ima3.currentAd && this.player.ima3.currentAd.getVastMediaBitrate()) {
      bitrate = this.player.ima3.currentAd.getVastMediaBitrate()
    }
    return bitrate
  },

  getCreativeId: function () {
    if (this.player.ima3 && this.player.ima3.currentAd) {
      return this.player.ima3.currentAd.getCreativeAdId() || this.player.ima3.currentAd.getCreativeId()
    }
  },

  registerListeners: function () {
    // Enable playhead monitor
    this.monitorPlayhead(true, false)

    /* youbora.Util.logAllEvents(this.player.on, [
                    null,
                    'ima3-ready',
                    'ima3error',
                    'ima3-ad-error',
                    'ima3-started',
                    'ima3-complete',
                    'ima3-paused',
                    'ima3-resumed',
                    'ads-request',
                    'ads-load',
                    'ads-ad-started',
                    'ads-ad-ended',
                    'ads-pause',
                    'ads-play',
                    'ads-click',
                    'ads-pod-started',
                    'ads-pod-ended',
                    'ads-allpods-completed'
                ]) */
    this.references = {}
    if (this.player.ima3) {
      // Register listeners
      this.references['ima3-started'] = this.startJoinListener.bind(this)
      this.references['ima3-paused'] = this.pausedListener.bind(this)
      this.references['ima3-resumed'] = this.resumedListener.bind(this)
      this.references['ima3-complete'] = this.adEndedListener.bind(this)
      this.references['ima3-skipped'] = this.skippedListener.bind(this)
      this.references['ima3-ad-error'] = this.errorListener.bind(this)
    } else {
      // Register listeners
      this.references['ads-ad-started'] = this.startJoinListener.bind(this)
      this.references['ads-pause'] = this.pausedListener.bind(this)
      this.references['ads-play'] = this.resumedListener.bind(this)
      this.references['ads-ad-ended'] = this.adEndedListener.bind(this)
    }
    this.references['ads-pod-ended'] = this.podEndListener.bind(this)
    this.references['ads-click'] = this.clickListener.bind(this)
    this.references['ads-first-quartile'] = this.firstQuartileListener.bind(this)
    this.references['ads-midpoint'] = this.secondQuartileListener.bind(this)
    this.references['ads-third-quartile'] = this.thirdQuartileListener.bind(this)

    if (this.player) Object.keys(this.references).forEach(function (key) { this.player.on(key, this.references[key]) }.bind(this))
  },

  startJoinListener: function (e) {
    if (this.plugin._adapter) this.plugin._adapter.firePause()
    this.fireStart()
    this.fireJoin()
  },

  loadedListener: function (e) {
    this.fireStart()
  },

  contentPauseRequestedListener: function (e) {
    this.fireStart()
  },

  startedListener: function (e) {
    this.fireJoin()
  },

  pausedListener: function (e) {
    this.firePause()
  },

  resumedListener: function (e) {
    this.fireResume()
  },

  completeListener: function (e) {
    var playheadVal = this.plugin.requestBuilder.lastSent.adPosition === youbora.Constants.AdPosition.Preroll ? 0 : this.plugin._adapter.lastPlayhead
    this.fireStop({ playhead: playheadVal })
    if (this.plugin._adapter) this.plugin._adapter.fireResume()
  },

  skippedListener: function (e) {
    this.fireSkip()
    if (this.plugin._adapter) this.plugin._adapter.fireResume()
  },

  adEndedListener: function (e) {
    var playheadVal = this.plugin.requestBuilder.lastSent.adPosition === youbora.Constants.AdPosition.Preroll ? 0 : this.plugin._adapter.lastPlayhead
    this.fireStop({ playhead: playheadVal })
  },

  errorListener: function (e) {
    if (e.getError && e.getError()) {
      var error = e.getError()
      this.fireError(error.getCode(), error.getMessage())
    } else {
      this.fireError('Ad error')
    }
  },

  clickListener: function (e) {
    var clickurl = null
    if (this.player.ima3 && this.player.ima3.currentAd && this.player.ima3.currentAd.g) {
      clickurl = this.player.ima3.currentAd.g.clickThroughUrl
    }
    this.fireClick(clickurl)
  },

  firstQuartileListener: function (e) {
    this.fireQuartile(1)
  },

  secondQuartileListener: function (e) {
    this.fireQuartile(2)
  },

  thirdQuartileListener: function (e) {
    this.fireQuartile(3)
  },

  podEndListener: function (e) {
    this.fireBreakStop()
  },

  unregisterListeners: function () {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      Object.keys(this.references).forEach(function (key) { this.player.off(key, this.references[key]) }).bind(this)
      this.references = {}
    }
  }
})

module.exports = FreewheelAdsAdapter
